// extracted by mini-css-extract-plugin
export default {"hr":"styles_hr__PlGXO"};